"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mapHelpers_1 = require("../map/mapHelpers");
class ShowPost {
    constructor(container, map, baseClass, zoomMarker) {
        this.container = container;
        this.map = map;
        this.baseClass = baseClass;
        this.zoomMarker = zoomMarker;
        this.addMarkerPostPairAddedListener();
    }
    addMarkerPostPairAddedListener() {
        this.container.addEventListener('postMarkerPairAdded', (e) => {
            const customEvent = e;
            const postMarkerPair = customEvent.detail;
            this.setupPostClickListener(postMarkerPair);
        });
    }
    setupPostClickListener(postMarkerPair) {
        var _a;
        const fullPostElement = (_a = postMarkerPair.post.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(`.${this.baseClass}__post-full`);
        const backButton = fullPostElement === null || fullPostElement === void 0 ? void 0 : fullPostElement.querySelector(`.${this.baseClass}__button-back`);
        if (!fullPostElement || !backButton)
            return;
        this.showPost(postMarkerPair, fullPostElement, backButton);
        this.hidePostListener(postMarkerPair, fullPostElement, backButton);
    }
    showPost(postMarkerPair, fullPostElement, backButton) {
        postMarkerPair.post.addEventListener('click', () => {
            if (fullPostElement.classList.contains('is-open'))
                return;
            this.closeAlreadyOpenPosts();
            this.scrollToMap();
            fullPostElement.classList.remove('u-display--none');
            fullPostElement.classList.add('is-open');
            // This makes removes the animation after it ran.
            // Using animationend event listener would be better but can also cause a bug in this case.
            setTimeout(() => {
                fullPostElement.style.animationDuration = '0s';
            }, 200);
            fullPostElement.classList.remove('is-closed');
            this.container.classList.add('has-open-post');
            fullPostElement.setAttribute('aria-hidden', 'false');
            document.body.classList.add('u-overflow--hidden');
            this.zoomMarker.zoom(postMarkerPair.marker);
            backButton.focus();
        });
    }
    hidePostListener(postMarkerPair, fullPostElement, backButton) {
        backButton.addEventListener('click', () => {
            this.hidePost(postMarkerPair, fullPostElement, backButton);
        });
    }
    hidePost(postMarkerPair, fullPostElement, backButton) {
        (0, mapHelpers_1.invalidateSize)(this.map);
        // Sets the animation duration back to the original value
        fullPostElement.style.animationDuration = '0.2s';
        fullPostElement.classList.remove('is-open');
        fullPostElement.classList.add('is-closed');
        setTimeout(() => {
            fullPostElement.classList.add('u-display--none');
        }, 200);
        this.container.classList.remove('has-open-post');
        fullPostElement.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('u-overflow--hidden');
        postMarkerPair === null || postMarkerPair === void 0 ? void 0 : postMarkerPair.post.focus();
    }
    closeAlreadyOpenPosts() {
        this.container.querySelectorAll(`.${this.baseClass}__post-full.is-open`).forEach((fullPostElement) => {
            const backButton = fullPostElement.querySelector(`.${this.baseClass}__button-back`);
            if (backButton) {
                this.hidePost(null, fullPostElement, backButton);
            }
        });
    }
    scrollToMap() {
        const rect = this.container.getBoundingClientRect();
        if (rect.top > 0) {
            window.scrollBy(0, rect.top);
        }
    }
}
exports.default = ShowPost;
